import React, { useEffect, useState } from "react";

export default function Countdown({ startsAt, onReady }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const target = startsAt ? new Date(startsAt).getTime() : NaN;
  const diff = isNaN(target) ? 0 : Math.max(0, target - now);
  const ready = !isNaN(target) && diff === 0;

  useEffect(() => {
    if (ready && onReady) onReady();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  if (!startsAt || isNaN(target)) return null;

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  const boxes = [
    { label: "days", value: days },
    { label: "hours", value: hours },
    { label: "min", value: minutes },
    { label: "sec", value: seconds },
  ];

  return (
    <div data-testid="countdown" className="glass-red-glow rounded-2xl p-6 relative overflow-hidden">
      <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-red-600/20 blur-3xl" />
      <div className="relative">
        <div className="text-xs uppercase tracking-[0.3em] text-red-300 font-mono mb-3">
          {ready ? "Ready to go live" : "Starts in"}
        </div>
        <div className="grid grid-cols-4 gap-2 sm:gap-3">
          {boxes.map((b) => (
            <div
              key={b.label}
              className={`rounded-xl px-2 py-3 sm:px-4 text-center ${
                ready ? "glass-red pulse-glow" : "glass-dark"
              }`}
            >
              <div className="font-display font-black text-2xl sm:text-3xl md:text-4xl font-mono tracking-tight leading-none">
                {String(b.value).padStart(2, "0")}
              </div>
              <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mt-1">
                {b.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
